import React from 'react';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

export const CallListDrawer = ({ onClose, onCreateCall, onEditCall }) => (
  <FPDrawer FPDrawerProps={{ open: true }} CardHeaderProps={{ title: 'Calls' }} onClose={onClose}>
    <div>Calls list placeholder.</div>
  </FPDrawer>
);
